
import axios from 'axios'
import Swal from 'sweetalert2'
import * as EmailValidator from 'email-validator';

export default function onSubmit(fullname, email, phonenumber, zoom, packageId, getParticipant, getPayment, history) {
    if (email === '') {
        return Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Data form registrasi masih belum lengkap'
        })
    } else if (fullname === '') {
        return Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Data form registrasi masih belum lengkap'
        })
    }
    else if (phonenumber === '') {
        return Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Data form registrasi masih belum lengkap'
        })
    } else if (zoom === '') {
        return Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Data form registrasi masih belum lengkap'
        })
    } else if (EmailValidator.validate(email) !== true) {
        return Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Format email harus benar'
        })
    }

    if (getPayment === '' && getParticipant != "") {
        return Swal.fire({
            title: 'Mau pakai data lama atau baru ?',
            showCancelButton: true,
            confirmButtonText: `Update Data`,
            denyButtonText: `Batal`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                let createPaymentPackage = await axios.post(`${process.env.REACT_APP_API}/participant/payment/package/create`, { participant_id: getParticipant.id, package_id: packageId, is_main_user: true })
                return history.push({
                    pathname: '/participant/register/biodata',
                    state: {
                        countParticipant: 1,
                        name: fullname,
                        email,
                        no_wa: phonenumber,
                        zoom_user: zoom,
                        is_main_user: true,
                        packageId,
                        getParticipant,
                        getPayment: createPaymentPackage.data
                    }
                })
            }
        })
    }

    if (getPayment !== '') {
        return Swal.fire({
            title: 'Mau pakai data lama atau baru ?',
            showCancelButton: true,
            confirmButtonText: `Update Data`,
            denyButtonText: `Batal`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                let createPaymentPackage = await axios.post(`${process.env.REACT_APP_API}/participant/payment/package/create`, { participant_id: getParticipant.id, package_id: packageId, is_main_user: true })
                return history.push({
                    pathname: '/participant/register/biodata',
                    state: {
                        countParticipant: 1,
                        name: fullname,
                        email,
                        no_wa: phonenumber,
                        zoom_user: zoom,
                        is_main_user: true,
                        packageId,
                        getParticipant,
                        getPayment: createPaymentPackage.data
                    }
                })
            }
        })
    }


    return history.push({
        pathname: '/participant/register/biodata',
        state: {
            countParticipant: 1,
            name: fullname,
            email,
            no_wa: phonenumber,
            zoom_user: zoom,
            is_main_user: true,
            packageId,
            getParticipant,
            getPayment
        }
    })

    // Swal.showLoading()

    // axios.post(`${process.env.REACT_APP_API}/participant/register`, {
    //     first_name: fullname.split(" ", 1)[0],
    //     last_name: fullname.split(" ").slice(1).join(' '),
    //     email,
    //     no_wa: phonenumber,
    //     zoom_user: zoom,
    //     package_id: packageId
    // })
    //     .then(function (response) {
    //         Swal.close()
    //     })
    //     .catch(function (error) {
    //         Swal.close()
    //         if (error.response) {
    //             if (error.response.status === 403) {
    //                 return Swal.fire({
    //                     icon: 'error',
    //                     title: 'Oops...',
    //                     text: 'Email mu sudah terdaftar'
    //                 })
    //             }
    //             return Swal.fire({
    //                 icon: 'error',
    //                 title: 'Oops...',
    //                 text: error
    //             })
    //         } else {
    //             return Swal.fire({
    //                 icon: 'error',
    //                 title: 'Oops...',
    //                 text: error
    //             })
    //         }
    //     })
}